import store from '../../../store';
export default function checkIfCanUpdateQuestions() {
  let exists = false;
  let scopes = store.getters.userScopes;
  exists = scopes.includes('manage_questions_update');
  return exists;
}
